import { Button, Col, Form, Row, Space, theme } from "antd";
import Map from "../../fragments/map";
import { useCallback, useEffect, useState } from "react";
import { useSetting } from "../../util/settings";

const MapFormItem = ({ value = { center: { lat: 48.1372039, lng: 11.6478594 }, zoom: 13 }, onChange }: any) => {
  const [initialValue, setInitialValue] = useState<any>(null);

  useEffect(() => {
    setInitialValue(initialValue => initialValue ?? value);
  }, [value, setInitialValue])

  const onChangeInternal = useCallback((evt: any) => {
    const newValue = {
      center: evt.target.getCenter(),
      zoom: evt.target.getZoom(),
    }
    onChange(newValue);
  }, [onChange])

  return <div style={{ width: "100%", height: "50em" }}>
    <Map initialCenter={initialValue?.center} initialZoom={initialValue?.zoom} center={value?.center} zoom={value?.zoom} onMoveEnd={onChangeInternal} onZoomEnd={onChangeInternal} />
  </div>
}

export const useMapSetting = () => {
  return useSetting("map", "application", {
    initialMapPosition: { 
      center: { lat: 48.1372039, lng: 11.6478594 }, 
      zoom: 13 
    }
  });
}

function MapSettings() {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  
  const [setting, updateSetting] = useMapSetting();

  useEffect(() => {
    form.setFieldsValue(setting);
  }, [form, setting])

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = useCallback((values) => {
    updateSetting(values);
  }, [updateSetting]);

  return (
    <>
      <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
        <h2>Karteneinstellungen</h2>
        <Row>
          <Col span={24}>
            <Form.Item 
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                name={["initialMapPosition"]}
                label="Initialer Kartenausschnitt"
              >
                <MapFormItem />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Space size="small">
            <Button loading={false} type="primary" htmlType="submit">
              Speichern
            </Button>
          </Space>
        </div>
      </Form>
    </>
  )
}

export default MapSettings;